import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { fetchEmailTemplates } from "../../../lib/api/resources/emailTemplates";
import { emailTemplateColumns } from "./lib/constants/emailTemplateColumns";
import { PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";

export const EmailTemplatesList = () => {
  const emailTemplatesQuery = useQuery({
    queryKey: ["emailTemplates"],
    queryFn: fetchEmailTemplates,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/email-templates/create">
          <Button icon={<PlusOutlined />}>Nieuwe E-mail template</Button>
        </Link>
      </Space>
      <Table
        columns={emailTemplateColumns}
        dataSource={emailTemplatesQuery.data}
        loading={emailTemplatesQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
